export default {
  title: "Merci d'avoir soumis vos informations pour recevoir des paiements",
  description:
    "La vérification par Stripe peut prendre jusqu'à 48 heures. En attendant, vous pouvez passer aux étapes suivantes. Nous vous informerons par e-mail dès que vos informations seront confirmées.",
};
